import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@material-ui/core/Grid';
import { QeeColorButtonSecondary } from './qeeColorButton'; // Assuming this is a button component similar to the one used in SacsFilterBar

import pinpointmap from '../assets/pinpointmap.png';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: theme.palette.background.default,
        zIndex: 1000,
        padding: theme.spacing(1),
        paddingTop: theme.spacing(0),
        [theme.breakpoints.down('md')]: {
            //position: 'relative',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        },
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
        },
    },
    formControls: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        },
    },
    formControl: {
        margin: theme.spacing(3),
        minWidth: 120
    },
    picture: {
        width: 100,
        height: 60,
        borderRadius: 5,
        marginRight: 10,
        objectFit: 'cover',
    },
    cardTitle: {
        marginBottom: theme.spacing(0.5),
        maxWidth: 320,
    },
    boldText: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '64ch', // limit to 64 characters
    },
    greyText: {
        color: theme.palette.text.secondary,
        fontSize: '0.8rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '64ch', // limit to 64 characters
    },
    errorText: {
        color: 'red',
        marginTop: theme.spacing(1),
    },
    actionButton: {
        marginTop: theme.spacing(1),
        height: '42px',
        width: 'auto',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
    },
    buttonLabel: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
}));

const OrgsFilterBar = ({ fac, discipline, radius, discs, radii, handleDisciplineChange, handleRadiusChange, handleToggleMap, isMdUp, showMap, error }) => {
    const classes = useStyles();
    const [anchorElDiscipline, setAnchorElDiscipline] = useState(null);
    const [anchorElRadius, setAnchorElRadius] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingState, setLoadingState] = useState(null);

    const handleMenuClick = (event, setAnchorEl) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = (setAnchorEl) => {
        setAnchorEl(null);
    };

    const handleActionSelect = (value, handleChange, setAnchorEl) => {
        setLoadingState(value);
        handleCloseMenu(setAnchorEl);

        if (typeof handleChange === 'function') {
            handleChange({ target: { value } });
        }
    };

    const getLabelForValue = (value, items) => {
        const item = items.find(item => item.value == value); // do not change this, it must compare evtl. string with integer '100'==100
        return item ? item.label : '...';
    };

    const renderFilterButton = (label, currentValue, items, handleChange, anchorEl, setAnchorEl) => (
        <FormControl className={classes.formControl}>
            <Typography className={classes.buttonLabel}>{label}</Typography>
            <QeeColorButtonSecondary
                disableElevation
                className={classes.actionButton}
                onClick={(e) => handleMenuClick(e, setAnchorEl)}
                fullWidth
            >
                {isLoading && loadingState === 'menu' ? <CircularProgress size={24} /> : getLabelForValue(currentValue, items)}
            </QeeColorButtonSecondary>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleCloseMenu(setAnchorEl)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                {items.map((item, index) => (
                    <MenuItem key={index} onClick={(e) => { e.stopPropagation(); handleActionSelect(item.value, handleChange, setAnchorEl); }}>
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </FormControl>
    );

    return (
        <>
            {error && (
                <Typography className={classes.errorText}>
                    Error fetching organizations: {error}
                </Typography>
            )}
            <Box className={classes.toolbar}>
                <Box className={classes.formControls}>
                    <Grid container direction="row">
                        <Grid item>
                            <Tooltip title="Karte anzeigen / verbergen">
                                <a href='#' onClick={handleToggleMap}><img src={pinpointmap} className={classes.picture} alt="Toggle Map" /></a>
                            </Tooltip>
                        </Grid>
                        {isMdUp && (
                            <Grid item>
                                <div className={classes.cardTitle}><Typography className={classes.boldText} variant='body1'>{fac.fac_name}</Typography></div>
                                <div className={classes.cardTitle} style={{ marginTop: 0 }}><Typography className={classes.greyText} variant='body2'>{fac.fac_type_text}</Typography></div>
                                <div className={classes.cardTitle}><Typography className={classes.greyText} variant='body2'>{fac.addr_gvalue_o.label}</Typography></div>
                            </Grid>
                        )}
                    </Grid>
                    {renderFilterButton("Spezialisierung", discipline, discs.map(disc => ({ value: disc.type, label: disc.name })), handleDisciplineChange, anchorElDiscipline, setAnchorElDiscipline)}
                    {renderFilterButton("Radius", radius, radii, handleRadiusChange, anchorElRadius, setAnchorElRadius)}
                </Box>
            </Box>
        </>
    );
};

export default OrgsFilterBar;
